import axios from "axios";

//admin.ly-gps.com:8810
https: //允许跨域携带Cooke
axios.defaults.withCredentials = true;
var ipPort =
  (ipObj[ipIndex].is_ssl ? "https://" : "http://") +
  ipObj[ipIndex].ip +
  ipObj[ipIndex].port;

axios.imUrl =
  "ws://" + ipObj[ipIndex].ip + ipObj[ipIndex].imPort + "/gps-server-im";
//默认
axios.defaults.baseURL = ipPort + "/cloud-admin-server-sys";
//平台web服务
axios.ipPort = ipPort;
axios.plat = "8cbe2e69-1852-41fe-8af1-cba581905c8d";

//调度服务
axios.auth = ipPort + "/cloud-security-oauth";
axios.commonAuth = ipPort + "/cloud-common-server-auth";
axios.csr = ipPort + "/cloud-admin-server-csr";
axios.com = ipPort + "/cloud-common-server-log";
axios.bm = ipPort + "/cloud-common-server-bm";
axios.dm = ipPort + "/cloud-common-server-dm";
axios.swm = ipPort + "/cloud-ep-server-swm";
axios.mwm = ipPort + "/cloud-ep-server-mwm";
axios.lbs = ipPort + "/cloud-common-server-lbs";
axios.msg = ipPort + "/cloud-common-server-msg";
axios.alarm = ipPort + "/cloud-common-server-alarm";
axios.report = ipPort + "/cloud-common-server-report";
axios.cost = ipPort + "/cloud-common-server-cost";
axios.event = ipPort + "/cloud-ep-server-event";
axios.oss = ipPort + "/cloud-common-server-oss";
axios.rule = ipPort + "/cloud-common-server-rule";
axios.work = ipPort + "/cloud-ep-server-work";
axios.gc = ipPort + "/cloud-ep-server-gc";
axios.upf = ipPort + "/cloud-ep-server-upf";
axios.cmd = ipPort + "/cloud-common-server-cmd";
axios.dpc = ipPort + "/cloud-car-server-dpc";
axios.flow = ipPort + "/cloud-common-server-flow";
axios.dpm = ipPort + "/cloud-rmm-server-dpm";

axios.interceptors.request.use(
  function(config) {
    var json = JSON.parse(sessionStorage.getItem(axios.plat));
    axios.keyObj = json;

    if (json != null) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.accessToken = json.accessToken;
      config.headers.identityId = json.identityId;
      config.headers.platformId = json.platformId;
      config.headers.customerId = json.customerId;
      config.headers.identityType = json.identityType;
      //config.headers[Content-Type] = 'multipart/form-data';
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
import Vue from "vue";
// 添加响应拦截器
axios.interceptors.response.use(
  function(res) {
    if (res.data.code == 500) {
      console.log(res);
      var aaa = document.getElementById("axiosContent");
      aaa.click();
      aaa.innerHTML = "服务异常(500)";
    } else if (res.data.code == 701) {
      sessionStorage.removeItem(axios.plat);
      window.location.reload(); //刷新页面
    } else if (res.data.code == 200) {
      return res;
    } else {
      var aaa = document.getElementById("axiosContent");
      aaa.click();
      var mes = "";
      if (res.data.data!=null) {
        mes = "," + res.data.data.message;
      }
      aaa.innerHTML = res.data.message+mes;
      console.log(res);
    }
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);



//////////////////
// WEBPACK FOOTER
// ./config/axios.js
// module id = null
// module chunks = 